var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"stamp-list stamp-grid"},_vm._l((_vm.userAsStampList),function(item,index){return _c('AsStampStatusListItem',{key:index,on:{"click-stamp":function($event){return _vm.clickStamp(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }